var productShowThumbs = new Swiper(".tb-product-show .tb-product-show-thumbs", {
  spaceBetween: 8,
  slidesPerView: isMobile() ? 5 : 'auto',
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  observer: true,
  observeParents: true,
});
var productShow = new Swiper(".tb-product-show .tb-product-show-slide", {
  loop: true,
  spaceBetween: 10,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".tb-product-show .swiper-button-next",
    prevEl: ".tb-product-show .swiper-button-prev",
  },
  thumbs: {
    swiper: productShowThumbs,
  },
});


if(!isMobile()){
  $(".tb-product-show-image").imagezoomsl({
    zoomrange: [3, 3]
  });
}

if(IsAppleStore()){
  $('.tb-product-video-play').hide()
}
// 复制折扣码
let codeCopy = document.querySelectorAll('.tb-product-coupon-copy');
let clipboard = new Clipboard(codeCopy);
let toastEn =  $('.coupon-toast').data('en')
let toastFr =  $('.coupon-toast').data('fr')
let toastEs =  $('.coupon-toast').data('es')
let toastIt =  $('.coupon-toast').data('it')
let prefix = pathname.substr(0,3);
let toastText;
if(prefix == '/fr'){
	toastText = toastFr;
}else if(prefix == '/es'){
	toastText = toastEs;
}else if(prefix == '/it'){
  toastText = toastIt;
}else{
  toastText = toastEn;
}
clipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>"+ toastText +"</div>"
  $('.tb-product-coupon-wrap').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


var bodyworkSlide = new Swiper(".tb-product-grid-slide", {
  spaceBetween: 0,
  pagination: {
    el: ".tb-product-grid-slide .swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        return;
      }
      this.params.spaceBetween = 0;
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 10;
      } else {
        this.disable();
      }
    },
  },
});

var sceneSlide = new Swiper(".tb-product-slideshow .tb-product-slideshow-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 24,
  scrollbar: {
    el: ".tb-product-slideshow-swiper .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".tb-product-slideshow .swiper-button-next",
    prevEl: ".tb-product-slideshow .swiper-button-prev",
  },
  on: {
    init: function () {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    }
  }
});

var socialSlide = new Swiper(".tb-product-social-media-swiper", {
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
      } else {
        this.disable();
      }
    },
  }
});

$(function () {
  // 服务选项卡首次加载
  $('.tb-product-serve-tab span').eq(0).addClass('active')
  $('.tb-product-serve-tab-content .tb-product-serve-tab-item').eq(0).addClass('active')
  let couponLen = $('.tb-product-coupon .tb-product-coupon-item').length;
  couponLen == 0 && $('.tb-product-coupon-btn').remove();
  // 选项切换
  $('.tb-product-variant-select-val').click(function (e) {
    $(this).parent().toggleClass('active');
    $(this).parent().next().slideToggle();
  });

  $('.tb-product-variant-select-list li').click(function () {
    let text = $(this).text();
    let id = $(this).data('id');
    $(this).parent().prev().find('.tb-product-variant-select-val').val(text)
    $(this).parent().slideUp();
    $(this).parent().prev().removeClass('active');
    $('#variantId').val(id)
    $('.tb-product-variant-hidden').find('option').attr('selected', false);
    $('.tb-product-variant-hidden').find(`option[value='${id}']`).attr('selected',true)
  })


  // 加减数量
  $('.tb-product-qty-min').click(function () {
    let qtyValue = parseInt($('.tb-product-qty-val').val());
    qtyValue !== 1 && qtyValue--;
    qtyValue == 1 ? $(this).addClass('disabled') : $(this).removeClass('disabled')
    $('.tb-product-qty-val').val(qtyValue)
  })

  $('.tb-product-qty-add').click(function () {
    let qtyValue = parseInt($('.tb-product-qty-val').val());
    qtyValue++;
    qtyValue == 1 ? $('.tb-product-qty-min').addClass('disabled') : $('.tb-product-qty-min').removeClass('disabled')
    $('.tb-product-qty-val').val(qtyValue)
  })
  $('.tb-product-payment-more p').click(function () {
    $(this).next().slideToggle();
  })


  $('.tb-product-serve-tab span').click(function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('.tb-product-serve-tab-item').eq($(this).index()).addClass('active').siblings().removeClass('active')
  })

  $('.tb-product-coupon-btn').click(function () {
    $('.tb-product-coupon-item:not(first-child)').toggleClass('active')
  })

  let paymentList = $('.tb-payment-list').html();
  $('.tb-product-payment-details').html(paymentList)
  if (!isMobile) {
    $('.tb-product-handle-checkout').on("mouseover mouseout", '.shopify-payment-button__more-options', function (event) {
      if (event.type == "mouseover") {
        $('.tb-product-payment-details').slideDown();
      } else if (event.type == "mouseout") {
        //鼠标离开
        $('.tb-product-payment-details').slideUp();
      }
    })
  }
  if (isMobile || $(window).width() <= 768) {
    $('.icon-notes').click(function () {
      $('.tb-product-payment-details').slideToggle();
    });
  }


  let productVideo = document.querySelector('#productVideo')
  $('.tb-product-video').hover(function () {
    $('#productVideo').attr('controls', true)
  }, function () {
    $('#productVideo').attr('controls', false)
  });
  $('.tb-product-video-play').click(function () {
    $(this).fadeOut();
    productVideo.play();
  })
  if (productVideo) {
    productVideo.addEventListener('play', function () { //开始
      $('.tb-product-video-play').fadeOut();
    });
    productVideo.addEventListener('pause', function () { //暂停
      $('.tb-product-video-play').fadeIn();
    });
    productVideo.addEventListener('ended', function () { //结束
      $('.tb-product-video-play').fadeIn();
    }, false);
  }

  $('.tb-product-spec-box dt').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    } else {
      $(this).addClass('active');
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    }
  })

  $('.tb-product-data-title.down').click(function () {
    if ($(this).next().is(':hidden')) {
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    } else {
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    }
  })

  $('.tb-product-faq-item h4').click(function () {
    $(this).toggleClass('active')
    $(this).next().slideToggle();
  })
  // 点击楼层跳跃
  var flag = true //设置标识。防止出现跑马灯
  let hdHeight;
  if (sessionStorage.getItem('barStatus') || !$('.tb-product-tabs-list').attr('data-barstatus')) {
    hdHeight = 72;
  } else if ($('.tb-product-tabs-list').attr('data-barstatus')) {
    hdHeight = 112;
  }
  if (flag) {
    $(window).scroll(function () {
      var scrollT = $(window).scrollTop()
      var len = $(".tb-product-tab-main").length
      for (let i = 0; i < len; i++) {
        var bannerGap = $(".tb-product-tab-main")[i].offsetTop - $('.tb-product-tabs-list').height() - hdHeight;
        if (scrollT > bannerGap) {
          $(".tb-product-tabs-item").eq(i).addClass("active").siblings().removeClass("active")
        }
      }
    })
  }
  $(".tb-product-tabs-item").click(function () {
    flag = false;
    var index = $(this).index() //获取当前点击元素的索引  
    // $(".tb-product-tabs-item").removeClass('active');
    // $(this).addClass("active");
    if (index == 2) {
      $('.tb-product-pack-box').slideDown()
    } else if (index == 3) {
      $('.tb-product-faq-box').slideDown()
    }
    var top = $(".tb-product-tab-main").eq(index).offset().top - $('.tb-product-tabs-list').height() - hdHeight; //获取每个内容到顶部的距离 
    $("html,body").stop(true).animate({
      "scrollTop": top + 5
    }, function () {
      flag = true
    })
  })

  $('.stockout-content .iconfont').click(function(){
    $('.stockout-modal').hide();
  })
})



// 添加到购物车
let currentProduct = document.getElementById('productPage'); //当前产品ID
let variantId = document.getElementById('variantId'); //当前产品变体
let numInput = document.getElementById('productQty'); //购买页产品加购数量
let loading = document.getElementById('loading'); //加载
$('.tb-product-addBtn').click(function (e) {
  let id = variantId.value || currentProduct.getAttribute('data-id');
  let quantity = numInput.value;
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    id,
    quantity
  }
  loading.classList.add('active');
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
        $('.tb-product-warning').fadeOut();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        $('.tb-product-warning').fadeIn();
        loading.classList.remove('active');
        $('.tb-product-warning p').html(responseText.description)
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  })
})



// 打开购物车
function toggleCart(type) {
  loading.classList.remove('active');
  let cartModal = document.querySelector('.tb-shop-cart');
  let shade = document.querySelector('.tb-shade');
  if (type == 'open') {
    cartModal.classList.add('show')
    shade.classList.add('show')
  } else if (type == 'add') {
    cartModal.classList.add('show')
    setTimeout(() => {
      cartModal.classList.remove('show')
      shade.classList.remove('show')
    }, 5000)
  } else {
    cartModal.classList.remove('show')
    shade.classList.remove('show')
  }
}

$('.tb-product-coupon-sale').click(function(){
  $('.tb-product-coupon-hint').fadeIn();
  setTimeout(() => {
    $('.tb-product-coupon-hint').fadeOut();
  }, 3000);
})

$('.tb-product-coupon-hint i').click(function(){
  $('.tb-product-coupon-hint').fadeOut();
})



// var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
//   if (window.ShopifyBuy) {
//     if (window.ShopifyBuy.UI) {
//       ShopifyBuyInit();
//     } else {
//       loadScript();
//     }
//   } else {
//     loadScript();
//   }
//   function loadScript() {
//     var script = document.createElement('script');
//     script.async = true;
//     script.src = scriptURL;
//     (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
//     script.onload = ShopifyBuyInit;
//   }
//   function ShopifyBuyInit() {
//     var client = ShopifyBuy.buildClient({
//       domain: 'eu-turboant.myshopify.com',
//       storefrontAccessToken: 'c8f4117fa731ac782169bf417e0b3cee',
//     });
//     let productBtn = document.getElementById('product-component');
//     let productId = productBtn.getAttribute('data-id');
//     ShopifyBuy.UI.onReady(client).then(function (ui) {
//       ui.createComponent('product', {
//         id: productId,
//         node: document.getElementById('product-component'),
//         moneyFormat: '%7B%7Bamount_with_comma_separator%7D%7D%E2%82%AC',
//         options: {
//           "product": {
//             iframe: false,
//             "buttonDestination": "checkout",
//             "contents": {
//               "img": false,
//               "title": false,
//               "price": false
//             },
//             "classes": {
//               button: "tb-fixed-checkout"
//             },
//             // "text": {
//             //   "button": "BUY IT NOW"
//             // }
//           }
//         }
//       });
//     });
//   }

// checkout按钮
$('#product-checkout-button').click(function () {
  const variantId = $('#variantId').val() || currentProduct.getAttribute('data-id');
  const quantity = $('#productQty').val() || 1;
  
  const mutation = `
    mutation {
      cartCreate(
        input: {
          lines: [
            {
              quantity: ${quantity}
              merchandiseId: "gid://shopify/ProductVariant/${variantId}"
            }
          ]
        }
      ) {
        cart {
          id
          checkoutUrl
        }
      }
    }
  `;

  fetch('/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'c8f4117fa731ac782169bf417e0b3cee'
    },
    body: JSON.stringify({ query: mutation })
  })
  .then(response => response.json())
  .then(result => {
    if (result.data && result.data.cartCreate && result.data.cartCreate.cart) {
      window.location.href = result.data.cartCreate.cart.checkoutUrl;
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
});

  // 订阅提交
$("#pre-sell-subscribe").click(function () {
  // 此处为请求
  $.ajax({
    url: 'https://backend.turboant.com/index/api/dealshopifycustomerTurboantPre',
    type: 'post',
    data: {
      account:'eu-turboant.myshopify.com',
      email: $('#pre-sell-email').val(),
      tag: $('#pre-sell-subscribe').data('tag'),
    },
    dataType: 'json',
    success: (res) => {
        const { status, msg } = res;
        if(status === 1){
          $('#pre-sell-subscribe-success').show();
        }else{
          $('#pre-sell-subscribe').append(`<div class='tb-toast'>${msg}</div>`);
          setTimeout(function () {
            $('.tb-toast').remove();
          }, 1000)
        }
    }
  });
});


var sceneSlide2 = new Swiper(".tb-product-slideshow .tb-product-slideshow-swiper2", {
  slidesPerView: isMobile() ? 'auto' : 4,
  spaceBetween: 24,
  scrollbar: {
    el: ".tb-product-slideshow-swiper2 .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".tb-product-slideshow .swiper-button-next",
    prevEl: ".tb-product-slideshow .swiper-button-prev",
  },
  on: {
    init: function () {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    }
  }
});

var sceneSwiper = new Swiper(".tb-product-scene-swiper", {
  slidesPerView: isMobile() ? 1.3 : 3,
  spaceBetween: isMobile() ? 12 : 24,
  on: {
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 12;
        this.params.slidesPerView = 1.3;
      } else {
        this.disable();
        this.params.spaceBetween = 24;
        this.params.slidesPerView = 3;
      }
    },
  },
});


// 倒计时
let time = $('#countdown').data('time')
$(`#countdown`).timeTo({
  timeTo: new Date(time),
  theme: "black",
  displayDays: 2,
  displayCaptions: true,
  fontSize: !isMobile() ? 30 : 24,
  captionSize: !isMobile() ? 14 : 12,
  lang: 'en',
  countdown: true
});